<template>
  <h2 class="ttl_background3  mx-auto my-10 h1">{{ TitleName }}</h2>
</template>

<script>
  export default {
    props: {
      TitleName: {
        type: String,
        default: "default",
        required: true,
      },
    },
  };
</script>
<style scoped>
  .ttl_background3 {
    text-align: center;
    color: rgb(var(--v-theme-primary));
    -webkit-box-reflect: below -10px -webkit-linear-gradient(
        top,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0) 10%,
        rgba(0, 0, 0, 0.6)
      );
  }
  h2{font-family: heisei-mincho-std,  sans-serif;}
</style>
